import React from 'react';
import { withRouter } from 'react-router-dom';

import FlatButton from 'material-ui/FlatButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton/IconButton';

import Dialog from 'material-ui/Dialog';

import ChangePassword from './ChangePassword';

import DataService from '../../services/DataService';
import LocalStorageService from '../../services/LocalStorageService';

var ls = LocalStorageService;
var ds = DataService;

const ImgIconButtonStyle = {
  width: '60px',
  height: '60px'
};

const listItemStyle = {
  paddingLeft: '50px' // 36 + 16, algin with sub list
};

class NavRightList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_partner: ls.getPartner() ? true : false,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  handleChange = (event, value) => {
    if (value == '/login') {
      ds.postLogout({
        notification_id: ls.getNotificationIds()
      }, data => {
        this.props.history.push(value);
        state.dispatch({ type: SET_USER, user: {} });
      }, err => {
        this.props.history.push(value);
        state.dispatch({ type: SET_USER, user: {} });
      });

    } else {
      this.props.history.push(value);
    }
  }

  resetPassword(e) {
    this.setState({
      dialog: {
        open: true,
        body: <ChangePassword unMountMe={this.closeDialog.bind(this)} />,
        actions: []
      }
    });
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });
  }

  render() {
    return (
      <div>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>
        <ul className="list-unstyled float-right">

          <li style={{ marginRight: '10px' }}>
            <IconMenu
              iconButtonElement={<IconButton style={ImgIconButtonStyle}><img src={this.state.is_partner ? "assets/images/man.png" : "assets/images/logo.png"} alt="" className="rounded-circle img30_30" /></IconButton>}
              onChange={this.handleChange}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              targetOrigin={{ horizontal: 'right', vertical: 'top' }}
              menuStyle={{ minWidth: '150px' }}
            >
              {this.props.user && this.props.user.name ?
                <li style={{ listStyle: "none", marginLeft: "15px", fontSize: "1.2rem" }}>{this.props.user.name}</li> : null}
              {this.props.user && this.props.user.email ?
                <li style={{ listStyle: "none", marginLeft: "15px", fontSize: "0.8rem", color: "$gray-600" }}>{this.props.user.email}</li> : null}
              <MenuItem
                value="/app/dashboard"
                primaryText="Dashboard"
                style={{ fontSize: '14px', lineHeight: '48px' }}
                innerDivStyle={listItemStyle}
                leftIcon={<i className="material-icons">home</i>}
              />
              <MenuItem
                onClick={() => this.resetPassword()}
                primaryText="Change Password"
                innerDivStyle={listItemStyle}
                style={{ fontSize: '14px', lineHeight: '48px' }}
                leftIcon={<i className="material-icons">build</i>}
              />
                {/* <MenuItem
                value="/app/settings"
                primaryText="Settings"
                innerDivStyle={listItemStyle}
                style={{ fontSize: '14px', lineHeight: '48px' }}
                leftIcon={<i className="material-icons">settings</i>}
              /> */}
              <MenuItem
                value="/login"
                primaryText="Log Out"
                innerDivStyle={listItemStyle}
                style={{ fontSize: '14px', lineHeight: '48px' }}
                leftIcon={<i className="material-icons">forward</i>}
              />
            </IconMenu>
          </li>
        </ul>
      </div>
    );
  }
}

module.exports = withRouter(NavRightList);



// WEBPACK FOOTER //
// ./components/Header/NavRightList.js